import { render, staticRenderFns } from "./NotificationConfigRow.vue?vue&type=template&id=2e3299bc&scoped=true&"
import script from "./NotificationConfigRow.vue?vue&type=script&lang=js&"
export * from "./NotificationConfigRow.vue?vue&type=script&lang=js&"
import style0 from "./NotificationConfigRow.vue?vue&type=style&index=0&id=2e3299bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3299bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
